const locale = $('#front').data('front-locale')

const authentication = {
    login: {
        url: '',
        disableLoginInputs() {
            $('#login fieldset, #login button').attr('disabled', 'disabled')
        },
        enableLoginInputs() {
            $('#login fieldset, #login button').removeAttr('disabled')
        },
        loginData() {
            const email = $('#login input[name="email"]').val()
            const password = $('#login input[name="password"]').val()
            const remember = $('#login input[name="remember"]').val()

            return {email, password, remember}
        },
        handleValidationErrors({response}) {
            if (response && response.status === 422) {
                const errors = response.data.errors

                if (errors.email) {
                    $('.login-email .email-errors').text(errors.email.join(';'))
                }

                if (errors.password) {
                    $('.login-password .password-errors').text(errors.password.join(';'))
                }
            }

            if (response && response.status === 403) {
                // console.log(response.data.errors)

                if (response.data.type === 1) {
                    window.location.href = `/${locale}/cannot-login-to-site/${response.data.user_id}`
                } else if (response.data.type === 2) {
                    window.location.href = `/${locale}/registrations/user/${response.data.user_id}`
                } else if (response.data.type === 3) {
                    window.location.href = `/${locale}/password/expired/${response.data.email}`
                }
            }
        },
        init() {
            const $login = $('#login')

            this.url = $login.attr('action')

            $login.on('submit', event => {
                event.preventDefault()
                authentication.toggleLoading('login')
                authentication.clearErrors()
                this.disableLoginInputs()

                axios
                    .post(this.url, this.loginData())
                    .finally(() => {
                        authentication.toggleLoading('login')
                        this.enableLoginInputs()
                    })
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = response.data.intended
                        }
                    })
                    .catch(error => {
                        this.handleValidationErrors(error)
                    })
            })
        },
    },

    register: {
        url: '',
        recaptchaWidgetId: null,

        waitForRecaptcha(cb) {
            const interval = setInterval(() => {
                if (window.grecaptcha && window.grecaptcha.render && window.RECAPTCHA_SITE_KEY) {
                    clearInterval(interval)
                    cb()
                }
            }, 50)
        },
        renderRecaptcha() {
            if (!$('#login-register').hasClass('is-visible')) return

            const el = document.getElementById('register-recaptcha')
            if (!el) return

            // avoid double render
            if (this.recaptchaWidgetId !== null) return

            this.recaptchaWidgetId = window.grecaptcha.render(el, {
                sitekey: window.RECAPTCHA_SITE_KEY,
                callback: token => this.onRecaptchaSuccess(token),
                'expired-callback': () => this.onRecaptchaExpired(),
            })
        },
        onRecaptchaSuccess(token) {
            $('#register-g-recaptcha-response').val(token)
            $('.register-recaptcha .recaptcha-errors').text('')
        },
        onRecaptchaExpired() {
            $('#register-g-recaptcha-response').val('')
        },
        resetRecaptcha() {
            this.onRecaptchaExpired()
            if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                window.grecaptcha.reset(this.recaptchaWidgetId)
            }
        },

        disableRegisterInputs() {
            $('#register fieldset, #register button').attr('disabled', 'disabled')
        },
        enableRegisterInputs() {
            $('#register fieldset, #register button').removeAttr('disabled')
        },
        registerData() {
            const email = $('#register input[name="email"]').val()
            const password = $('#register input[name="password"]').val()
            const user_type = $('#register select[name="user_type"]')
                .data('select')
                .val()

            const accept_terms = $('#register input[name="accept_terms"]').is(':checked')

            const recaptcha = $('#register-g-recaptcha-response').val()

            return {email, password, user_type, accept_terms, 'g-recaptcha-response': recaptcha}
        },
        handleValidationErrors({response}) {
            if (response && response.status === 422) {
                const errors = response.data.errors

                if (errors.email) {
                    $('.register-email .email-errors').text(errors.email.join(';'))
                }

                if (errors.password) {
                    $('.register-password .password-errors').text(errors.password.join(';'))
                }

                if (errors.user_type) {
                    $('.register-user_type .user_type-errors').text(errors.user_type.join(';'))
                }

                if (errors.accept_terms) {
                    $('.register-accept_terms .accept_terms-errors').text(
                        errors.accept_terms.join(';'),
                    )
                }

                if (errors['g-recaptcha-response']) {
                    $('.register-recaptcha .recaptcha-errors').text(
                        errors['g-recaptcha-response'].join(';'),
                    )
                }
            }

            if (response && response.status === 403) {
                // console.log(response.data.errors)

                if (response.data.type === 1) {
                    window.location.href = `/${locale}/already-registered-on-another-auction-organizer/${response.data.user_id}`
                } else if (response.data.type === 2) {
                    window.location.href = `/${locale}/already-registered-on-auction-platform-operator/${response.data.user_id}`
                }
            }
        },
        showAfterRegistrationContent() {
            $('#login-register .tab-wrap .tab-single.active').removeClass('active')
            $('#login-register .tab-content .tab-content-single.active').removeClass('active')
            $('#login-register .tab-wrap .tab-single[data-content=1]').addClass('active')
            $('#login-register .tab-content .tab-content-single[data-content=3]').addClass('active')
        },
        init() {
            const $register = $('#register')

            this.url = $register.attr('action')

            /*this.waitForRecaptcha(() => {
                this.renderRecaptcha()
            })*/

            let registerForm = document.getElementById('register')
            $register.on('submit', event => {
                event.preventDefault()
                authentication.clearErrors()

                const token = $('#register-g-recaptcha-response').val()
                if (!token) {
                    $('.register-recaptcha .recaptcha-errors').text(Lang.get('javascript.user_requests.request_not_a_robot'))
                    return
                }

                authentication.toggleLoading('register')
                this.disableRegisterInputs()

                axios
                    .post(this.url, this.registerData())
                    .finally(() => {
                        authentication.toggleLoading('register')
                        this.enableRegisterInputs()
                        this.resetRecaptcha()
                    })
                    .then(response => {
                        const $front = $('#front')

                        if (response.data.success) {
                            // fbq('track', 'Lead', {
                            //     value: 9.00,
                            //     currency: $front.data('site-currency')
                            // })
                            // window.location.href = response.data.intended

                            this.showAfterRegistrationContent()
                        }
                    })
                    .catch(error => {
                        // console.log('Login error', error)
                        this.handleValidationErrors(error)
                    })
            })
        },
    },

    init() {
        $('.tab-content-single form').each(function () {
            $(this).validator({
                focus: true,
                disable: false,
            })
        })

        $(document).on('click', '.modal-tab-toggle[data-target="login-register"]', (e) => {
            const tab = String($(e.currentTarget).data('tab-content'))

            // Only for Register tab
            if (tab !== '1') return

            authentication.loadRecaptchaScript(() => {
                authentication.register.renderRecaptcha()
            })
        })

        $(document).on('click', '#login-register .tab-single[data-toggle-tab-modal][data-content="1"]', () => {
            authentication.loadRecaptchaScript(() => {
                authentication.register.renderRecaptcha()
            })
        })

        this.login.init()
        this.register.init()
    },

    toggleLoading(type) {
        $(`#${type}-loading`).toggleClass('d-none')
    },

    clearErrors() {
        $('.tab-content-single form .with-errors').empty()
    },

    loadRecaptchaScript(cb) {
        // If grecaptcha is already ready
        if (window.grecaptcha && window.grecaptcha.render) {
            cb()
            return
        }

        // Queue callbacks
        this._recaptchaCallbacks = this._recaptchaCallbacks || []
        this._recaptchaCallbacks.push(cb)

        // Avoid injecting multiple times
        if (this._recaptchaLoading) return
        this._recaptchaLoading = true

        // If script tag already exists, just wait until grecaptcha is ready
        if (document.getElementById('recaptcha-api')) {
            return this._waitForRecaptchaReady()
        }

        const s = document.createElement('script')
        s.id = 'recaptcha-api'
        s.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${locale}`
        s.async = true
        s.defer = true

        // CSP nonce (important)
        if (window.CSP_NONCE) {
            s.setAttribute('nonce', window.CSP_NONCE)
        }

        s.onload = () => this._waitForRecaptchaReady()
        s.onerror = () => {
            this._recaptchaLoading = false
            this._recaptchaCallbacks = []
            console.error('[reCAPTCHA] Failed to load api.js')
        }

        document.head.appendChild(s)
    },

    _waitForRecaptchaReady() {
        const interval = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.render) {
                clearInterval(interval)
                this._recaptchaLoading = false

                const callbacks = this._recaptchaCallbacks || []
                this._recaptchaCallbacks = []
                callbacks.forEach(fn => fn())
            }
        }, 50)
    },
}

authentication.init()
